import {
    takeEvery, all, put, call,
} from 'redux-saga/effects';
import API from '../common/API';
import * as Actions from '../actions/OrganizerList';
import { BOOTH_TYPE } from '../common/Constants';

function* getEventProducts(action) {
    const endpoint = `/api/v1/event/${action.payload.event}/product/`;
    try {
        const response = yield call(
            API.get,
            {
                endpoint,
                body: action.payload.params,
            },
        );
        yield put(Actions.getEventProductsReceived(response));
    } catch (error) {
        yield put(Actions.getEventProductsReceiveFailure(yield error));
    }
}

function* getEventProductsByBooth(action) {
    const endpoint = `/api/v1/event/${action.payload.event}/product/`;
    try {
        const response = yield call(
            API.get,
            {
                endpoint,
                body: action.payload.params,
            },
        );
        switch (action.payload.boothType) {
            case BOOTH_TYPE.SMALL:
                yield put(Actions.getEventProductsSmallZoneReceived(response));
                break;
            case BOOTH_TYPE.STANDARD:
                yield put(Actions.getEventProductsStandardZoneReceived(response));
                break;
            case BOOTH_TYPE.BIG:
                yield put(Actions.getEventProductsBigZoneReceived(response));
                break;
            case BOOTH_TYPE.GRAND:
                yield put(Actions.getEventProductsGrandZoneReceived(response));
                break;
            default:
                break;
        }
    } catch (error) {
        switch (action.payload.boothType) {
            case BOOTH_TYPE.SMALL:
                yield put(Actions.getEventProductsSmallZoneReceiveFailure(yield error));
                break;
            case BOOTH_TYPE.STANDARD:
                yield put(Actions.getEventProductsStandardZoneReceiveFailure(yield error));
                break;
            case BOOTH_TYPE.BIG:
                yield put(Actions.getEventProductsBigZoneReceiveFailure(yield error));
                break;
            case BOOTH_TYPE.GRAND:
                yield put(Actions.getEventProductsGrandZoneReceiveFailure(yield error));
                break;
            default:
                break;
        }
    }
}

export default function* login() {
    yield all([
        takeEvery('GET_EVENT_PRODUCTS_REQUEST', getEventProducts),
        takeEvery('GET_EVENT_PRODUCTS_SMALL_ZONE_REQUEST', getEventProductsByBooth),
        takeEvery('GET_EVENT_PRODUCTS_STANDARD_ZONE_REQUEST', getEventProductsByBooth),
        takeEvery('GET_EVENT_PRODUCTS_BIG_ZONE_REQUEST', getEventProductsByBooth),
        takeEvery('GET_EVENT_PRODUCTS_GRAND_ZONE_REQUEST', getEventProductsByBooth),
    ]);
}
